export default __webpack_public_path__ + "static/media/MalabarSpinach.36375e38.jpg";